// Centralised discount logic for the shop.
// Original ebook prices and their current promotional prices.
const DISCOUNT_MAP = {
  29.99: 19.99,
  49.99: 35.99,
};

export function getPricing(originalPrice) {
  const original = Number(originalPrice);
  const sale = DISCOUNT_MAP[original];
  if (!sale || sale >= original) {
    return { original, sale: null, savings: 0, percentOff: 0, hasDiscount: false };
  }
  const savings = +(original - sale).toFixed(2);
  const percentOff = Math.round((savings / original) * 100);
  return { original, sale, savings, percentOff, hasDiscount: true };
}

export function formatUSD(amount) {
  return `$${Number(amount).toFixed(2)}`;
}
